<template>
  <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" :rules="rules" label-width="100px">
            <el-form-item label="手机号：" prop="username">
                <el-input style="width: 300px" maxlength="11" placeholder="请输入手机号" v-model="formData.username" @keyup.enter.native="submitForm('formData')"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" prop="verify_code" style="position: relative;">
                <el-input style="width: 300px" maxlength="6" type="" placeholder="请输入验证码" v-model="formData.verify_code"></el-input>
                <div class="yzm_btn" @click="obtainVerification()">{{txt}}</div>
            </el-form-item>
            <el-form-item label="密码：" prop="new_password">
                <el-input style="width: 300px" maxlength="16" show-password placeholder="请输入6~15位密码" v-model="formData.new_password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="password">
                <el-input style="width: 300px" maxlength="16" show-password placeholder="请输入确认密码" v-model="formData.password"></el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/auth/register";
import { isvalidMobile } from "@/utils/validate";
export default {
    data() {
        const validateEmail = (rule, value, callback) => {
            if (!isvalidMobile(value)) {
                callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        const validateverify_code = (rule, value, callback) => {
            if (value.length < 4) {
                callback(new Error("验证码长度不要小于4位数"));
            } else {
                callback();
            }
        };
        const validatenew_password = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error("密码长度不要小于6位数"));
            } else {
                callback();
            }
        };
        const validatepassword = (rule, value, callback) => {
            if (value != this.formData.new_password) {
                callback(new Error("2次输入的密码不相同，请重新输入"));
            } else {
                callback();
            }
        };
        return {
            formData: {
                username: "",
                verify_code: "",
                new_password: ""
            },
            txt: "获取验证码",
            disabled: false,
            rules: {
                username: [
                    {
                        required: true,
                        validator: validateEmail,
                        trigger: "blur"
                    }
                ],
                verify_code: [
                    {
                        required: true,
                        validator: validateverify_code,
                        trigger: "blur"
                    }
                ],
                new_password: [
                    {
                        required: true,
                        validator: validatenew_password,
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        required: true,
                        validator: validatepassword,
                        trigger: "blur"
                    }
                ]
            },
            loading: false
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 确认修改
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    this.loading = true;
                    api.profilePassword(this.formData).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: "密码修改成功！",
                                type: "success"
                            });
                            this.handleClose();
                        } else {
                            this.loading = false;
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        }
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        //获取验证码
        obtainVerification() {
            if (this.disabled) {
                return;
            }
            if (!isvalidMobile(this.formData.username)) {
                return this.$message.error("请输入正确的手机号");
            }
            const obj = {};
            obj.phone = this.formData.username;
            api.send_verify_code(obj).then(res => {
                if (res.code == 0) {
                    this.timeOut();
                } else {
                    return this.$message.error(res.message);
                }
            });
        },
        //注册验证码的60S
        timeOut() {
            this.disabled = true;
            let num = 60;
            this.txt = num + "s";
            const nt = setInterval(() => {
                if (num <= 0) {
                    clearInterval(nt);
                    this.txt = "重新获取";
                    this.disabled = false;
                } else {
                    num--;
                    this.txt = num + "s";
                }
            }, 1000);
        },
        // 关闭弹窗
        handleClose() {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback");
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.yzm_btn {
    width: 80px;
    height: 40px;
    position: absolute;
    right: 60px;
    top: 0px;
    line-height: 40px;
    border-radius: 0 6px 6px 0;
    text-align: center;
    color: #fff;
    font-size: 13px;
    background: #107bc5;
    cursor: pointer;
    border: none;
}
</style>
